import {createGtm} from "@gtm-support/vue-gtm";
import router from "./router";

export const gtm = createGtm({
    id: "GTM-M4792X9",
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    defer: true

});
